import { cn } from "@/libs/utils";

function WebViewSkeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-[#2b2b2b]",
        className,
      )}
      {...props}
    >
      <div className="absolute inset-0 animate-webviewSkeleton bg-[linear-gradient(90deg,#323232_25%,#3C3C3C_50%,#323232_75%)] bg-[length:200%_100%]" />
    </div>
  );
}

export { WebViewSkeleton };
